import Vue from "vue";
import moment from "moment-timezone";

const formatDateTime = function (value) {
  if (!value) return "";
  const date = moment(value);
  return date.isValid() ? moment(value).tz('America/Los_Angeles').format("L LT") : "";
};
const formatDateTimeSecond = function (value) {
  if (!value) return "";
  const date = moment(value);
  return date.isValid() ? moment(value).tz('America/Los_Angeles').format("L LTS") : "";
};
const formatUTCDateTime = function (value) {
  if (!value) return "";
  const date = moment(value);
  return date.isValid() ? `${moment(value).tz('America/Los_Angeles').format("L HH:mm")} (PST)` : "";
};
const formatUTCDate = function (value) {
  if (!value) return "";
  const date = moment(value);
  return date.isValid() ? `${moment(value).utc().format("L")}` : "";
};
const formatUTCWeek = function (value) {
  if (!value) return "";
  const date = moment(value);
  return date.isValid()
          ? `${moment(value).utc().format("M/D")}
          -${moment(value).endOf('week').utc().format("M/D/YY")}` : "";
};

const formatUTCMonth = function (value) {
  if (!value) return "";
  const date = moment(value);
  return date.isValid() ? `${moment(value).utc().format("MMM YY")}` : "";
};

const formatUTCQuarter = function (value) {
  if (!value) return "";
  const date = moment(value);
  return date.isValid() ? `q ${moment(value).utc().format("Qo YY")}` : "";
};

const formatUTCYear = function (value) {
  if (!value) return "";
  const date = moment(value);
  return date.isValid() ? `${moment(value).utc().format("YYYY")}` : "";
};
// eslint-disable-next-line complexity
const formatCurrency = function (value) {
  if (value === "" || value === undefined || value === null) return "";
  return `$ ${Number(value).toFixed(2)}`;
};

const formatUTCDateByType = (type, value)=> {
  const map = {
    'hourly':formatUTCDateTime,
    'daily' :formatUTCDate,
    'weekly' :formatUTCWeek,
    'monthly' :formatUTCMonth,
    'quarterly' :formatUTCQuarter,
    'yearly' :formatUTCYear,
  }

  return map[type] ? map[type](value) : value;
}

Vue.filter("formatDateTime", formatDateTime);
Vue.filter("formatDateTimeSecond", formatDateTimeSecond);
Vue.filter("formatUTCDateTime", formatUTCDateTime);
Vue.filter("formatUTCDate", formatUTCDate);
Vue.filter("formatCurrency", formatCurrency);

export default {
  formatDateTime,
  formatDateTimeSecond,
  formatUTCDateTime,
  formatUTCDate,
  formatCurrency,
  formatUTCDateByType
};

export {
  formatDateTime,
  formatDateTimeSecond,
  formatUTCDateTime,
  formatUTCDate,
  formatCurrency,
  formatUTCDateByType
};
